<div class="main-content profile-editor-page site-editor-page">
  <div class="container-fluid">
    <section class="profile-editor-page__hero">
      <div class="profile-editor-page__copy">
        <h1>{{ titulo }}</h1>
        <p>Dónde se espera a la gente y cómo registra en ese lugar.</p>
      </div>

      <div class="profile-editor-page__hero-actions">
        <button type="button" class="app-form-btn app-form-btn--secondary" [disabled]="guardando" (click)="volver()">
          Regresar
        </button>
        <button type="button" class="app-form-btn app-form-btn--primary" [disabled]="guardando || cargando" (click)="guardar()">
          <span class="material-icons">save</span>
          {{ guardando ? "Guardando…" : "Guardar sitio" }}
        </button>
      </div>
    </section>

    <div class="row profile-editor-page__layout site-editor-page__layout">
      <div class="col-xl-4 col-lg-5">
        <section class="profile-editor-page__card">
          <div class="profile-editor-page__card-header">
            <div class="site-editor-page__card-copy">
              <div class="profile-editor-page__card-title">
                <i class="material-icons">place</i>
                <span>Datos del sitio</span>
              </div>
              <span>Qué lugar es, de quién es y cómo se registra ahí.</span>
            </div>
          </div>

          <div class="profile-editor-page__card-body">
            <div class="row site-editor-page__grid">
              <div class="col-12">
                <mat-form-field appearance="outline" class="profile-editor-page__field">
                  <mat-label>Nombre del sitio</mat-label>
                  <input matInput aria-label="Nombre del sitio" [(ngModel)]="ubicacion.nombre" maxlength="120" />
                </mat-form-field>
              </div>

              <div class="col-12">
                <mat-form-field appearance="outline" class="profile-editor-page__field" subscriptSizing="dynamic">
                  <mat-label>Tipo</mat-label>
                  <mat-select [(ngModel)]="ubicacion.tipo" (selectionChange)="alCambiarTipo()">
                    <mat-option value="OFICINA_PROPIA">Oficina propia</mat-option>
                    <mat-option value="SITIO_CLIENTE">Sitio de cliente</mat-option>
                    <mat-option value="HOME_OFFICE">Home office</mat-option>
                  </mat-select>
                  <mat-hint>Separa a la gente propia de la asignada a clientes.</mat-hint>
                </mat-form-field>
              </div>

              <div class="col-12" *ngIf="esSitioDeCliente">
                <mat-form-field appearance="outline" class="profile-editor-page__field" subscriptSizing="dynamic">
                  <mat-label>Cliente</mat-label>
                  <mat-select [(ngModel)]="ubicacion.idCliente">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="buscadorCliente" [placeholderLabel]="'Buscar cliente'"
                        [noEntriesFoundLabel]="'No hay clientes con ese nombre'">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let cliente of clientesFiltrados" [value]="cliente.id">
                      {{ cliente.razonsocial }}
                    </mat-option>
                  </mat-select>
                  <mat-hint>Es el cliente que recibirá la lista de asistencia de este sitio.</mat-hint>
                </mat-form-field>
              </div>

              <div class="col-12">
                <mat-form-field appearance="outline" class="profile-editor-page__field" subscriptSizing="dynamic">
                  <mat-label>Cómo se registra aquí</mat-label>
                  <mat-select [(ngModel)]="ubicacion.canalRegistro">
                    <mat-option value="KIOSCO">Solo kiosco (huella)</mat-option>
                    <mat-option value="APP">Solo teléfono</mat-option>
                    <mat-option value="AMBOS">Kiosco y teléfono</mat-option>
                  </mat-select>
                  <mat-hint>En la mayoría de los sitios de cliente no hay kiosco.</mat-hint>
                </mat-form-field>
              </div>

              <div class="col-12">
                <mat-form-field appearance="outline" class="profile-editor-page__field" subscriptSizing="dynamic">
                  <mat-label>Zona horaria</mat-label>
                  <mat-select [(ngModel)]="ubicacion.zonaHoraria">
                    <mat-option *ngFor="let zona of zonas" [value]="zona">{{ zona }}</mat-option>
                  </mat-select>
                  <mat-hint>Con ella se decide si alguien llegó tarde.</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="col-xl-8 col-lg-7">
        <section class="profile-editor-page__card">
          <div class="profile-editor-page__card-header">
            <div class="site-editor-page__card-copy">
              <div class="profile-editor-page__card-title">
                <i class="material-icons">my_location</i>
                <span>Dónde está el sitio</span>
              </div>
              <span>Busque la dirección o dé clic en el mapa; el círculo es la geocerca.</span>
            </div>
          </div>

          <div class="profile-editor-page__card-body editor-ubicacion__mapa-body">
            <div class="site-editor-page__toggle-card">
              <div class="site-editor-page__toggle-copy">
                <strong>Exigir que el registro se haga dentro del sitio</strong>
                <span>Sólo aplica al registro desde el teléfono: quien no comparta su ubicación no podrá registrar aquí.</span>
              </div>
              <mat-slide-toggle [(ngModel)]="ubicacion.exigeGeocerca" aria-label="Exigir que el registro se haga dentro del sitio">
              </mat-slide-toggle>
            </div>

            <app-selector-ubicacion
              [latitud]="ubicacion.latitud"
              [longitud]="ubicacion.longitud"
              [radioMetros]="ubicacion.radioMetros"
              (cambio)="alElegirPunto($event)">
            </app-selector-ubicacion>

            <div class="row site-editor-page__grid editor-ubicacion__coordenadas">
              <div class="col-sm-4">
                <mat-form-field appearance="outline" class="profile-editor-page__field">
                  <mat-label>Latitud</mat-label>
                  <input matInput aria-label="Latitud" type="number" step="0.0000001" [(ngModel)]="ubicacion.latitud" />
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field appearance="outline" class="profile-editor-page__field">
                  <mat-label>Longitud</mat-label>
                  <input matInput aria-label="Longitud" type="number" step="0.0000001" [(ngModel)]="ubicacion.longitud" />
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field appearance="outline" class="profile-editor-page__field" subscriptSizing="dynamic">
                  <mat-label>Radio en metros</mat-label>
                  <input matInput aria-label="Radio en metros" type="number" [min]="radioMinimo" step="10" [(ngModel)]="ubicacion.radioMetros" />
                  <mat-hint>Mínimo {{ radioMinimo }} m: por debajo manda el error del GPS.</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
